'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export const NumberInputBox = forwardRef(({ className, ...props }, ref) => {
    return (_jsx("input", { ...props, ref: ref, type: "number", className: cn('flex-auto bg-transparent px-3 py-2.5 text-center text-body-3 font-medium text-metal-900 outline-none dark:text-white', className) }, "input"));
});
NumberInputBox.displayName = 'NumberInputBox';
